import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import { useLocation } from 'react-router-dom';

const PublicLayout = ({ children, isFullWidth }) => {
    const [headerHeight, setHeaderHeight] = useState(60);
    const location = useLocation();

    const isWebView = new URLSearchParams(location.search).get('webview') === 'true';

    useEffect(() => {
        if (!isWebView) {
            const header = document.querySelector('header');
            if (header) {
                setHeaderHeight(header.offsetHeight);
            }
        }
    }, [isWebView]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '100vh',
                backgroundColor: '#f9f9f9',
            }}
        >
            {/* Public Header */}
            {/* Conditionally Render Header */}
            {!isWebView && <PublicHeader />}

            {/* Main Content */}
            <main
                style={{
                    paddingTop: isWebView ? '0' : `${headerHeight + 16}px`,
                    ...(isFullWidth
                        ? {
                            paddingLeft: '0', // No padding for full-width sections
                            paddingRight: '0',
                            paddingTop: '64px',
                        }
                        : {
                            paddingLeft: '16px', // Default padding for constrained sections
                            paddingRight: '16px',
                            maxWidth: '1200px',
                            margin: '0 auto',
                        }),
                }}
            >
                {children}
            </main>

            {/* Footer */}
            {/* Conditionally Render Footer */}
            {!isWebView && (
                <footer
                    style={{
                        marginTop: 'auto',
                        padding: '16px 24px',
                        backgroundColor: '#34495e',
                        color: '#ecf0f1',
                        textAlign: 'center',
                        fontSize: '12px',
                        minHeight: '80px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <p style={{ margin: 0, color: '#ecf0f1' }}>
                        © Copyright {new Date().getFullYear()} Rigg Dynamics LLC{' '}
                        <span style={{ margin: '0 8px', color: '#ecf0f1' }}>|</span>
                        <Link
                            to="/privacy-policy"
                            style={{
                                color: '#ecf0f1',
                                textDecoration: 'none',
                                margin: '0 8px',
                            }}
                        >
                            Privacy Policy
                        </Link>
                        <span style={{ margin: '0 8px', color: '#ecf0f1' }}>|</span>
                        <Link
                            to="/terms-of-use"
                            style={{
                                color: '#ecf0f1',
                                textDecoration: 'none',
                                margin: '0 8px',
                            }}
                        >
                            Terms of Use
                        </Link>
                    </p>
                </footer>
            )}
        </div>
    );
};

export default PublicLayout;